export class LupHelper {
  enrollmentStatuses = {
    waitlisted: -4,
    partially_attended: -3,
    cancelled: -2,
    no_show: -1,
    not_started: 1,
    in_progress: 2,
    completed: 3,
    passed: 4,
    failed: 5,
    pending_review: 6,
    closed: 7,
    past_due: 8,
  };

  // The types of pages that can load into the learner view
  componentTypes = {
    exam: 1,
    scorm: 2,
    page: 3,
    assignment: 4,
    session: 5,
    training: 6,
    checklist: 7,
    linkedin_learning: 8,
    tin_can: 9,
    e_signature: 10,
  };
}
